import { render, staticRenderFns } from "./TenancyDocuments.vue?vue&type=template&id=a155b992&scoped=true&"
import script from "./TenancyDocuments.vue?vue&type=script&lang=js&"
export * from "./TenancyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDocuments.vue?vue&type=style&index=0&id=a155b992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a155b992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a155b992')) {
      api.createRecord('a155b992', component.options)
    } else {
      api.reload('a155b992', component.options)
    }
    module.hot.accept("./TenancyDocuments.vue?vue&type=template&id=a155b992&scoped=true&", function () {
      api.rerender('a155b992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/TenancyDocuments.vue"
export default component.exports